/**
 * mqtt 相关api
 */

import instance from '@/utils/axios';

const api = {
  subDeviceDetail: '/auth/addSnDetailUserId',
  unsubDeviceDetail: '/auth/removeSnDetailUserId',
  pushParam: '/device/pushParam'
};

/**
 * 订阅设备详情
 * @param {string[]} snList 设备序列号数组
 */
export function subDeviceDetail(snList) {
  return instance.post(api.subDeviceDetail, { snList });
}

/**
 * 取消订阅设备详情
 * @param {string[]} snList 设备序列号数组
 */
export function unsubDeviceDetail(snList) {
  return instance.post(api.unsubDeviceDetail, { snList });
}

/**
 * 设备详情 参数
 * @param {{sn: string}} params
 * @param {string} sn 设备sn
 */
export function pushParam(params) {
  return instance.get(api.pushParam, { params });
}

/**
 * 获取Mqtt配置
 * @param {string} clientId
 * @returns
 */
export function getMqttConfig(clientId) {
  return instance.post('/auth/mqttConfig', {
    clientId
  });
}
